import axios from "axios";

const useCustomField = () => {
  const apiUrls = process.env.REACT_APP_API_URLS;
  // const apiUrl = "https://zmmbe.etpl.cloud";
  // console.log(apiUrl);

  const submitCustomField = async (data) => {
    console.log("Hello");
    console.log(apiUrls);
    try {
      const response = await fetch(`${apiUrls}/buyer_settings/custom-fields/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });
      // console.log("Hello");

      // const response = await axios.post(
      //   `${apiUrls}/buyer_settings/custom-fields/`,
      //   data
      // );
      const responseData = await response.json(); // Parse the response JSON
      // const responseData = response.data;
      // const responseData = response.data;
      console.log("response", response);
      console.log("responseData", responseData);
      if (response.ok) {
        return {
          success: true,
          message: responseData.message || "Field added successfully!",
        };
      } else {
        console.log("Response", response.error);
        return {
          success: false,
          message:
            responseData.error || "Failed to add field. Please try again.",
        };
      }
    } catch (error) {
      return {
        success: false,
        message: "An error occurred while adding the field.",
      };
    }
  };

  return { submitCustomField };
};

export default useCustomField;
